import { Layout } from '@/features/auth/components/Layout';
import { useTranslation } from 'react-i18next';
import { RegistrationMailOnlyForm } from '../components/RegistrationMailOnlyForm';

export const RegistrationExpiredPage = () => {
  const { t } = useTranslation();

  return (
    <Layout>
      <div className="space-y-6">
        <div>
          <h2 className="text-2xl font-bold tracking-tight text-gray-900">
            {t('登録期限切れ')}
          </h2>
          <p className="mt-3 text-gray-600">
            {t('登録期限が切れてしまいました。')}
            {t(
              'もう一度メールアドレスを入力して、招待メールを受け取ってください。'
            )}
          </p>
        </div>
        <RegistrationMailOnlyForm />
      </div>
    </Layout>
  );
};
